import { createSlice } from "@reduxjs/toolkit";
import { defaultTablesLayoutState } from "./tables.state";
import { getTablesDataFormLocalStore, setTablesDataInLocalStore } from "./tables.localStore";
import { fetchSingleOutletLayoutsAsync, fetchOutletSingleLayoutAsync, deleteLayoutWithCallbackAsync } from "./tables.actions";
import { LoadState } from "../../constants/enum";


const tablesLayoutSlice = createSlice({
    initialState: defaultTablesLayoutState,
    name: "reservations",
    reducers: {
        // getTablesListSync: (state) => {
        //     const data = getTablesDataFormLocalStore()
        //     state.single_tables_layout.data.tables = data
        // },
        reserveTableByNumberSync: (state, action) => {
            const tableNumber = action.payload
            const newTablesList = state.single_tables_layout.data.tables.map((table) => {
                if (table.data.table_number === tableNumber) {
                    return {
                        ...table,
                        data: {
                            ...table.data,
                            availability: "RESERVED" as any
                        }
                    }
                }
                return table
            })
            state.single_tables_layout.data.tables = newTablesList
            setTablesDataInLocalStore(state.single_tables_layout.data.tables)
        },
        checkInTableByNumberSync: (state, action) => {
            const tableId = action.payload
            const newTablesList = state.single_tables_layout.data.tables.map((table) => {
                if (table.data.table_number === tableId) {
                    return {
                        ...table,
                        data: {
                            ...table.data,
                            availability: "CHECKED_IN" as any
                        }
                    }
                }
                return table
            })
            state.single_tables_layout.data.tables = newTablesList
            setTablesDataInLocalStore(state.single_tables_layout.data.tables)
        },
        clearTablesLayoutStateSync: (state) => {
            return defaultTablesLayoutState
        },

        // getSingleTablesInfoSync: (state, action) => {
        //     const data = getTablesDataFormLocalStore()
        //     const tableInfo = data.find((table) => table.id === action.payload)
        //     if (tableInfo) {
        //         state.selected_table = tableInfo
        //     }
        // },
    },
    extraReducers: (builder) => {
        // ############################# Outlet Multiple Layouts List Async ######################################
        builder.addCase(fetchSingleOutletLayoutsAsync.pending, (state, action) => {
            state.layouts_list_without_tables.loading = LoadState.pending
        })
        builder.addCase(fetchSingleOutletLayoutsAsync.fulfilled, (state, action) => {
            state.layouts_list_without_tables.loading = LoadState.succeeded
            state.layouts_list_without_tables.data = action.payload.data
            state.layouts_list_without_tables.totalRecords = action.payload.recordCount
            state.layouts_list_without_tables.error = null
        })
        builder.addCase(fetchSingleOutletLayoutsAsync.rejected, (state, action) => {
            state.layouts_list_without_tables.error = action.error.message as string
        })


        // #################################### Single Table Layout ##############################################
        builder.addCase(fetchOutletSingleLayoutAsync.pending, (state, action) => {
            state.single_tables_layout.loading = LoadState.pending
        })
        builder.addCase(fetchOutletSingleLayoutAsync.fulfilled, (state, action) => {
            state.single_tables_layout.loading = LoadState.succeeded
            state.single_tables_layout.data = action.payload
            state.single_tables_layout.error = null
        })
        builder.addCase(fetchOutletSingleLayoutAsync.rejected, (state, action) => {
            state.single_tables_layout.error = action.error.message as string
        })



        // #################################### Delete Single Layout ##############################################
        builder.addCase(deleteLayoutWithCallbackAsync.pending, (state, action) => {
            state.layouts_list_without_tables.loading = LoadState.pending
        })
        builder.addCase(deleteLayoutWithCallbackAsync.fulfilled, (state, action) => {
            state.layouts_list_without_tables.loading = LoadState.succeeded
            state.layouts_list_without_tables.data = action.payload
            state.layouts_list_without_tables.error = null
        })
        builder.addCase(deleteLayoutWithCallbackAsync.rejected, (state, action) => {
            state.layouts_list_without_tables.error = action.error.message as string
        })
    },
});

export const tablesLayoutReducer = tablesLayoutSlice.reducer;
export const {
    reserveTableByNumberSync,
    checkInTableByNumberSync,
    clearTablesLayoutStateSync,


} = tablesLayoutSlice.actions;
